import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ForgeSelect } from '@tylertech/forge-react';
import {
  getFilterSelector,
  selectSources,
  selectAllowedVersions,
} from 'common/components/AssetBrowser/selectors/filters';
import { Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import { SelectDropdownConfig } from '../config/filter-config';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import styles from './select-dropdown-filter.module.scss';

export const SelectDropdownFilter = ({ filterConfig }: { filterConfig: SelectDropdownConfig }) => {
  const dispatch: ThunkDispatch<any, unknown, AnyAction> = useDispatch();

  const value = useSelector(getFilterSelector(filterConfig.filterName));
  const sources = useSelector(selectSources);
  const versions = useSelector(selectAllowedVersions);

  const { label, dispatchAction, getOptions } = filterConfig;

  const getFilterOptions = () => {
    switch (filterConfig.filterName) {
      case Filters.Source:
        return getOptions(sources);
      case Filters.Version:
        return getOptions(versions);
      default:
        return getOptions();
    }
  };

  const options = getFilterOptions();

  const onChange = (selectedOption: string | null): void => {
    dispatch(dispatchAction(selectedOption));
  };

  // This is not expected to happen.
  if (options.length === 0) {
    return null;
  }

  // When there are only 2 options (All + one other), show the specific option instead of All
  const displayValue = options.length === 2 ? options[1].value : value || null;

  return (
    <div>
      <ForgeSelect
        className={styles['select-dropdown-filter']}
        label={label}
        label-position="block-start"
        value={displayValue}
        variant="filled"
        onChange={(e: { detail: string | null }) => onChange(e.detail || null)}
        options={options}
        data-testid={`select-dropdown-${filterConfig.filterName}`}
        disabled={options.length <= 2}
      />
    </div>
  );
};
